import React from "react";

import SectionHeader from "@cayuse/shared-react.components.section-header";
import PropTypes from "prop-types";

import BasePadding from "@cayuse/shared-react.components.base-padding";

import styles from "./styles.css";


const Subsection = ({
	children,
	buttons,
	title,
	headingType
}) => {
	return (
		<div data-component="Subsection" className={styles.subsection}>
			<SectionHeader header={title} buttons={buttons} headingType={headingType} /> {/* todo: not quite right, title is too big */}
			<BasePadding>
				{children}
			</BasePadding>
		</div>
	);
};

Subsection.propTypes = {
	buttons: PropTypes.arrayOf(PropTypes.node),
	children: PropTypes.node,
	title: PropTypes.string
};

export default Subsection;
